import { render } from "./ProjectCardPreviewDetails.vue?vue&type=template&id=01c66c30"
import script from "./ProjectCardPreviewDetails.vue?vue&type=script&lang=js"
export * from "./ProjectCardPreviewDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__